// @ts-nocheck
/* eslint-disable spire/export-styles */
import { getFocalPointStyles } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
// eslint-disable-next-line spire/fenced-imports
import { TS } from "@insite/shell/TS";
import * as React from "react";
// import { css } from "styled-components"; // Starter Custom Code

/* Starter Custom Code - Start */
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import getCssUnitField from "@store/Framework/Common/Fields/Toolkit/cssUnit";
import getGapPresetField from "@store/Framework/Common/Fields/Toolkit/gapPreset";
import getNumberTextField from "@store/Framework/Common/Fields/Toolkit/numberText";
import getVerticalGapField from "@store/Framework/Common/Fields/Toolkit/verticalGap";
import Block from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockPreserveSpacingField from "@store/Library/Components/Toolkit/Block/fields/preserveSpacing";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import * as cssLinter from "css";
import { css } from "styled-components";
/* Starter Custom Code - End */

type FlexChild = {
    fields: {
        flexGrow: number;
        flexShrink: number;
        flexBasis: string;
        // Starter Custom Code
        alignItems: string;
    };
};

const enum fields {
    flexZones = "flexZones",
    gap = "gap",
    direction = "direction",
    wrap = "wrap",
    justifyContent = "justifyContent",
    alignItems = "alignItems",
    alignContent = "alignContent",
    isFullWidth = "isFullWidth",
    fullWidthStylingType = "fullWidthStylingType",
    fullWidthColor = "fullWidthColor",
    fullWidthImage = "fullWidthImage",
    fullWidthImageFocalPoint = "fullWidthImageFocalPoint",
    // Starter Custom Code
    gapPreset = "gapPreset",
    blockPreserveSpacing = "blockPreserveSpacing",
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    gridVerticalGap = "gridVerticalGap",
    layoutMode = "layoutMode",
    customCSS = "customCSS",
    invertColor = "invertColor",
    padding = "padding",
    showBorder = "showBorder",
    borderWidth = "borderWidth",
    borderColor = "borderColor",
    borderRadius = "borderRadius",
}

/* Starter Custom Code - Start */
const gapPresetField = getGapPresetField(fields.gapPreset);
const gapField = getCssUnitField(fields.gap, { shorthands: ["row", "column"] });
const verticalGapField = getVerticalGapField(fields.gridVerticalGap);
const paddingField = getCssUnitField(fields.padding, { shorthands: ["top", "right", "bottom", "left"] });
const borderWidthField = getCssUnitField(fields.borderWidth, { shorthands: ["top", "right", "bottom", "left"] });
const borderRadiusField = getCssUnitField(fields.borderRadius, {
    shorthands: ["top-left", "top-right", "bottom-right", "bottom-left"],
});
const flexGrowField = getNumberTextField("flexGrow", { isChildDefinition: true, min: 0 });
const flexShrinkField = getNumberTextField("flexShrink", { isChildDefinition: true, min: 0 });
const flexBasisField = getCssUnitField("flexBasis", { isChildDefinition: true });
/* Starter Custom Code - End */

interface Props extends WidgetProps {
    fields: {
        [fields.flexZones]: FlexChild[];
        [fields.gap]: string; // Starter Custom Code
        [fields.direction]: string;
        [fields.wrap]: string;
        [fields.justifyContent]: string;
        [fields.alignItems]: string;
        [fields.alignContent]: string;
        [fields.isFullWidth]: boolean;
        [fields.fullWidthStylingType]: string;
        [fields.fullWidthColor]: string;
        [fields.fullWidthImage]: string;
        [fields.fullWidthImageFocalPoint]:
            | "topLeft"
            | "topCenter"
            | "topRight"
            | "centerLeft"
            | "center"
            | "centerRight"
            | "bottomLeft"
            | "bottomCenter"
            | "bottomRight";
        // Starter Custom Code
        [fields.gapPreset]: string;
        [fields.blockPreserveSpacing]: boolean;
        [fields.blockFullWidth]: boolean;
        [fields.blockVariant]: string;
        [fields.blockVariantSide]: string;
        [fields.blockMargin]: string;
        [fields.gridVerticalGap]: string;
        [fields.layoutMode]: boolean;
        [fields.customCSS]: string;
        [fields.invertColor]: boolean;
        [fields.padding]: string;
        [fields.showBorder]: boolean;
        [fields.borderWidth]: string;
        [fields.borderColor]: string;
        [fields.borderRadius]: string;
    };
}

const FlexRow = (props: Props) => {
    const {
        fields: {
            flexZones,
            gap,
            direction,
            wrap,
            justifyContent,
            alignItems,
            alignContent,
            isFullWidth,
            fullWidthStylingType,
            fullWidthColor,
            fullWidthImage,
            fullWidthImageFocalPoint,
            // Starter Custom Code
            gapPreset,
            blockPreserveSpacing,
            blockFullWidth,
            blockVariant,
            blockVariantSide,
            blockMargin,
            gridVerticalGap,
            layoutMode,
            customCSS,
            invertColor,
            padding,
            showBorder,
            borderWidth,
            borderColor,
            borderRadius,
        },
        id,
    } = props;

    const { isInShell } = useShellContext(); // Starter Custom Code
    const zoneElements: JSX.Element[] = [];

    for (let x = 0; x < flexZones.length; x += 1) {
        const wrapperProps = getWrapperProps(flexZones[x], isInShell); // Starter Custom Code
        zoneElements.push(
            <StyledWrapper key={x} {...wrapperProps} data-test-selector={`flexZone_${x}`}>
                <Zone normalWidth={true} contentId={id} zoneName={`FlexZone${x}`} />
            </StyledWrapper>,
        );
    }

    const fullWidthBackgroundCss = !isFullWidth
        ? undefined
        : fullWidthStylingType === "solidColor"
        ? css`
              ${
                  /* Starter Custom Code - Start */
                  ({ theme }) => cssProp("background-color", fullWidthColor, x => resolveColor(x, theme))
                  /* Starter Custom Code - End */
              }
          `
        : fullWidthStylingType === "image"
        ? css`
              background-image: url("${parseImageUrl(fullWidthImage).url}");
              background-size: cover;
              ${getFocalPointStyles(fullWidthImageFocalPoint)}
          `
        : undefined;

    /* Starter Custom Code - Start */
    const gapPresetData = gapPresetField.useParse(gapPreset);
    const gapFieldData = gapField.useParseToGridPreset(gap);
    const verticalGapFieldData = verticalGapField.useParse(gridVerticalGap);

    const verticalGap = gapPresetData?.vertical || verticalGapFieldData || gapFieldData?.vertical;
    const horizontalGap = gapPresetData?.horizontal || gapFieldData?.horizontal;

    const sharedCss = css`
        ${fullWidthBackgroundCss}
        ${({ theme }) => {
            if (showBorder) {
                return css`
                    ${cssProp("border-width", borderWidthField.parse(borderWidth))}
                    border-color: ${resolveColor(borderColor || "common.border", theme)};
                    border-style: solid;
                `;
            }
        }}
        ${breakpointValues(borderRadiusField.parse(borderRadius), "border-radius")}
    `;
    /* Starter Custom Code - End */

    const fieldStyle = css`
        /* Starter Removed - margin */
        display: flex;
        flex-direction: ${direction};
        flex-wrap: ${wrap};
        justify-content: ${justifyContent};
        align-items: ${alignItems};
        align-content: ${alignContent};
        /* Starter Removed - gap */
        ${breakpointValues(verticalGap, "row-gap") /* Starter Custom Code */}
        ${breakpointValues(horizontalGap, "column-gap") /* Starter Custom Code */}
        ${breakpointValues(paddingField.parse(padding), "padding") /* Starter Custom Code */}
        ${({ theme }: { theme: BaseTheme }) => {
            /* Starter Custom Code - Start */
            return layoutMode && !blockFullWidth && siteWidthStyles();
            /* Starter Custom Code - End */
        }}
        /* Starter Removed - fullWidthBackgroundCss */
        ${layoutMode && sharedCss /* Starter Custom Code */}
        ${invertColor && typographyInvertColorStyles() /* Starter Custom Code */}
        ${customCSS /* Starter Custom Code */}
    `;

    /* Starter Custom Code - Start */
    const flexWrapper = <StyledWrapper css={fieldStyle}>{zoneElements}</StyledWrapper>;

    if (layoutMode) {
        return flexWrapper;
    }

    return (
        <Block
            preserveSpacing={blockPreserveSpacing}
            fullWidth={blockFullWidth}
            variant={isFullWidth ? "background" : blockVariant}
            variantSide={blockVariantSide}
            margin={blockMargin}
            containerCss={sharedCss}
        >
            {flexWrapper}
        </Block>
    );
    /* Starter Custom Code - End */
};

function validateCssLength(value: string) {
    if (value === "") {
        return "";
    }
    const lengthRegex = /[\d]+([a-zA-Z]+|%)/gi;
    if (!lengthRegex.test(value) || value === "0") {
        return TS("Value must use a valid CSS length format (e.g. 10px or 30%)");
    }
    return null;
}

function getWrapperProps(options: FlexChild, isInShell?: boolean /* Starter Custom Code */) {
    if (!options || !options.fields) {
        return;
    }
    const zoneOptions = options.fields;
    return {
        css: css`
            min-width: 0;
            ${breakpointValues(flexBasisField.parse(zoneOptions.flexBasis), "flex-basis") /* Starter Custom Code */}
            ${breakpointValues(flexGrowField.parse(zoneOptions.flexGrow), "flex-grow") /* Starter Custom Code */}
            ${breakpointValues(flexShrinkField.parse(zoneOptions.flexShrink), "flex-shrink") /* Starter Custom Code */}
            /* Starter Custom Code - Start */
            display: flex;
            ${cssProp("align-items", zoneOptions.alignItems)}

            > div /* Zone */ {
                width: 100%;
                height: auto;

                ${() => {
                    if (zoneOptions.alignItems === "stretch") {
                        return css`
                            display: flex;
                            flex-direction: column;
                            flex-grow: 1;

                            > * /* Widgets */ {
                                flex-grow: inherit;
                            }

                            ${() => {
                                if (isInShell) {
                                    return css`
                                        > [data-widget],
                                        > [class^="ZoneWrapper"],
                                        > [class^="ZoneWrapper"] > [data-widget],
                                        > [class^="ZoneWrapper"] > [data-widget] > [class^="WidgetStyle"],
                                        > [class^="ZoneWrapper"]
                                            > [data-widget]
                                            > [class^="WidgetStyle"]
                                            > [class^="WidgetWrapper"] {
                                            display: inherit;
                                            flex-direction: inherit;
                                            flex-grow: inherit;

                                            > *:not([class^="WidgetClearer"]):not([class^="AddContainer"]) /* Widgets */ {
                                                flex-grow: inherit;
                                            }
                                        }
                                    `;
                                }
                            }}
                        `;
                    }
                }}
            }
            /* Starter Custom Code - End */
        `,
    };
}

/* Starter Custom Code - Start */
const defaultCustomCss = `& {

}`;

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};
/* Starter Custom Code - End */

const widgetModule: WidgetModule<Toolkit.FieldDefinition> /* Starter Custom Code */ = {
    component: FlexRow,
    definition: {
        canAdd: context => context.permissions?.canUseAdvancedFeatures || false,
        group: "Basic",
        icon: "distribute-spacing-vertical",
        fieldDefinitions: [
            /* Starter Custom Code - Start */
            {
                name: fields.layoutMode,
                displayName: "Layout Mode",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
            },
            gapPresetField.definition,
            /* Starter Custom Code - End */
            {
                ...gapField.definition, // Starter Custom Code
                // Starter Removed - name
                displayName: "Gap Between Zones",
                // Starter Removed - editorTemplate
                // Starter Removed - defaultValue
                fieldType: "Contextual",
                // Starter Removed - validate
                isVisible: widget => !widget.fields.gapPreset, // Starter Custom Code
            },
            {
                name: fields.direction,
                editorTemplate: "DropDownField",
                defaultValue: "row",
                fieldType: "Contextual",
                options: [
                    {
                        displayName: "Row",
                        value: "row",
                    },
                    {
                        displayName: "Row Reverse",
                        value: "row-reverse",
                    },
                    {
                        displayName: "Column",
                        value: "column",
                    },
                    {
                        displayName: "Column Reverse",
                        value: "column-reverse",
                    },
                ],
            },
            {
                name: fields.wrap,
                editorTemplate: "DropDownField",
                defaultValue: "nowrap",
                fieldType: "Contextual",
                options: [
                    {
                        displayName: "No Wrap",
                        value: "nowrap",
                    },
                    {
                        displayName: "Wrap",
                        value: "wrap",
                    },
                    {
                        displayName: "Wrap Reverse",
                        value: "wrap-reverse",
                    },
                ],
            },
            {
                name: fields.justifyContent,
                editorTemplate: "DropDownField",
                defaultValue: "flex-start",
                fieldType: "Contextual",
                options: [
                    {
                        displayName: "Start",
                        value: "flex-start",
                    },
                    {
                        displayName: "End",
                        value: "flex-end ",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    /* Starter Custom Code - Start */
                    {
                        displayName: "Space Between",
                        value: "space-between",
                    },
                    {
                        displayName: "Space Around",
                        value: "space-around",
                    },
                    {
                        displayName: "Space Evenly",
                        value: "space-evenly",
                    },
                    /* Starter Custom Code - End */
                ],
            },
            {
                name: fields.alignItems,
                editorTemplate: "DropDownField",
                defaultValue: "stretch",
                fieldType: "Contextual",
                options: [
                    {
                        displayName: "Stretch",
                        value: "stretch",
                    },
                    {
                        displayName: "Start",
                        value: "flex-start",
                    },
                    {
                        displayName: "End",
                        value: "flex-end",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    {
                        displayName: "Baseline",
                        value: "baseline",
                    },
                ],
            },
            {
                name: fields.alignContent,
                editorTemplate: "DropDownField",
                defaultValue: "normal",
                fieldType: "Contextual",
                isVisible: (item: HasFields) => {
                    return item.fields[fields.wrap]?.startsWith("wrap");
                },
                options: [
                    {
                        displayName: "Normal",
                        value: "normal",
                    },
                    {
                        displayName: "Start",
                        value: "start",
                    },
                    {
                        displayName: "End",
                        value: "end",
                    },
                    {
                        displayName: "Flex Start",
                        value: "flex-start",
                    },
                    {
                        displayName: "Flex End",
                        value: "flex-end",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    {
                        displayName: "Space Between",
                        value: "space-between",
                    },
                    {
                        displayName: "Space Around",
                        value: "space-around",
                    },
                    {
                        displayName: "Space Evenly",
                        value: "space-evenly",
                    },
                    {
                        displayName: "Stretch",
                        value: "stretch",
                    },
                    {
                        displayName: "Baseline",
                        value: "baseline",
                    },
                ],
            },
            {
                name: fields.isFullWidth,
                displayName: "Show Background", // Starter Custom Code
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fullWidthStylingType,
                displayName: "Background Styling", // Starter Custom Code
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Solid Color",
                        value: "solidColor",
                    },
                    {
                        displayName: "Image",
                        value: "image",
                    },
                ],
                defaultValue: "solidColor",
                horizontal: true,
                fieldType: "General",
                isVisible: widget => widget.fields.isFullWidth, // Starter Custom Code
            },
            {
                name: fields.fullWidthColor,
                displayName: "Background Color", // Starter Custom Code
                editorTemplate: "CustomColorPickerField", // Starter Custom Code
                defaultValue: "transparent",
                fieldType: "General",
                /* Starter Custom Code - Start */
                isVisible: widget => widget.fields.isFullWidth && widget.fields.fullWidthStylingType === "solidColor",
                /* Starter Custom Code - End */
            },
            {
                name: fields.fullWidthImage,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "General",
                /* Starter Custom Code - Start */
                isVisible: widget => widget.fields.isFullWidth && widget.fields.fullWidthStylingType === "image",
                /* Starter Custom Code - End */
            },
            {
                name: fields.fullWidthImageFocalPoint,
                displayName: "Focal Point",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Top Left", value: "topLeft" },
                    { displayName: "Top Center", value: "topCenter" },
                    { displayName: "Top Right", value: "topRight" },
                    { displayName: "Center Left", value: "centerLeft" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Center Right", value: "centerRight" },
                    { displayName: "Bottom Left", value: "bottomLeft" },
                    { displayName: "Bottom Center", value: "bottomCenter" },
                    { displayName: "Bottom Right", value: "bottomRight" },
                ],
                defaultValue: "center",
                fieldType: "General",
                hideEmptyOption: true,
                /* Starter Custom Code - Start */
                isVisible: widget => widget.fields.isFullWidth && widget.fields.fullWidthStylingType === "image",
                /* Starter Custom Code - End */
            },
            /* Starter Custom Code - Start */
            {
                name: fields.invertColor,
                displayName: "Invert Text Color",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.showBorder,
                displayName: "Show Border",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                ...borderWidthField.definition,
                defaultValue: "1",
                isVisible: x => x.fields.showBorder,
            },
            {
                name: fields.borderColor,
                displayName: "Border Color",
                editorTemplate: "CustomColorPickerField",
                defaultValue: "common.border",
                fieldType: "General",
                isVisible: x => x.fields.showBorder,
            },
            {
                ...borderRadiusField.definition,
            },
            {
                ...paddingField.definition,
            },
            /* Starter Custom Code - End */
            {
                name: fields.flexZones,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return translate("Zone");
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        ...flexGrowField.definition,
                        // Starter Removed - name
                        // Starter Removed - editorTemplate
                        defaultValue: "1", // Starter Custom Code
                        // Starter Removed - min
                    },
                    {
                        ...flexShrinkField.definition,
                        // Starter Removed - name
                        // Starter Removed - editorTemplate
                        defaultValue: "1", // Starter Custom Code
                        // Starter Removed - min
                    },
                    {
                        ...flexBasisField.definition, // Starter Custom Code
                        // Starter Removed - name
                        // Starter Removed - editorTemplate
                        // Starter Removed - defaultValue
                        // Starter Removed - validate
                    },
                    /* Starter Custom Code - Start */
                    {
                        name: "alignItems",
                        editorTemplate: "DropDownField",
                        defaultValue: "flex-start",
                        options: [
                            {
                                displayName: "Stretch",
                                value: "stretch",
                            },
                            {
                                displayName: "Start",
                                value: "flex-start",
                            },
                            {
                                displayName: "End",
                                value: "flex-end",
                            },
                            {
                                displayName: "Center",
                                value: "center",
                            },
                            {
                                displayName: "Baseline",
                                value: "baseline",
                            },
                        ],
                        tooltip: `Only applies if the global align-items is set to "Stretch"`,
                    },
                    /* Starter Custom Code - End */
                ],
            },
            /* Starter Custom Code - Start */
            {
                ...blockVariantField,
                name: fields.blockVariant,
                tab: advancedTab,
                isVisible: widget => !widget.fields.isFullWidth && !widget.fields.layoutMode,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                tab: advancedTab,
                isVisible: (widget, ...args) => {
                    return (
                        (blockVariantSideField.isVisible ? blockVariantSideField.isVisible(widget, ...args) : true) &&
                        !widget.fields.layoutMode
                    );
                },
            },
            {
                ...verticalGapField.definition,
                tab: advancedTab,
                isVisible: widget => !widget.fields.gapPreset,
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                tab: advancedTab,
                isVisible: widget => !widget.fields.layoutMode,
            },
            {
                ...blockPreserveSpacingField,
                name: fields.blockPreserveSpacing,
                tab: advancedTab,
                isVisible: widget => !widget.fields.layoutMode,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            /* Starter Custom Code - End */
        ],
    },
};

export default widgetModule;
